import Select, { components as defaultComponents } from 'react-select';
import { Icon } from 'common-components';

import { SearchControl, searchSelectStyles } from './SelectAsync';

type OptionType = {
  label: string
  value: string
};

export type RegularSelectPropsType = {
  options: OptionType[]
  value: string
  setValue: (value: string) => void
  valuesSelected: OptionType[]
  setValuesSelected: (values: OptionType[]) => void
  placeholder?: string
};
const SelectRegular = ({
  options,
  value,
  setValue,
  valuesSelected,
  setValuesSelected,
  placeholder,
}: RegularSelectPropsType) => {
  return (
    <Select
      options={options}
      value={value}
      isClearable
      isSearchable
      placeholder={placeholder}
      onChange={(option: OptionType) => {
        setValuesSelected([...valuesSelected, option]);
        setValue('');
      }}
      components={{
        Control: SearchControl,
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
        ClearIndicator: (props) => (
          <defaultComponents.ClearIndicator {...props}>
            <Icon width={18} height={18} icon="XClose" />
          </defaultComponents.ClearIndicator>
        ),
      }}
      styles={searchSelectStyles}
    />
  );
};

export default SelectRegular;
